import CardRow from "@/components/custom/Cards/CardRow";
import { PersonalizedCardRow } from "@/components/custom/Cards/PersonalizedCardRow";
import HeroClient from "@/components/custom/Hero/HeroClient";
import { PersonalizedHero } from "@/components/custom/Hero/PersonalizedHero";
import { ModuleErrorBoundary } from "@/components/custom/ModuleErrorBoundary";
import { getEntryOfContentType } from "@/lib/contentful/guards";
import { mapCardSectionExperiences } from "@/lib/ninetailed/mapCardSectionExperiences";
import { mapHeroExperiences } from "@/lib/ninetailed/mapHeroExperiences";
import type { TypeCardSection, TypeHero } from "@/types/contentful/generated";
import type { PageModule } from "./TypePageModule";

export function renderHeroModuleClient(module: PageModule) {
  const heroModule = getEntryOfContentType<TypeHero<undefined, string>>(module, "hero");
  if (!heroModule) return null;

  const experiences = mapHeroExperiences(heroModule.fields.nt_experiences);
  if (experiences.length > 0) {
    return (
      <ModuleErrorBoundary key={heroModule.sys.id}>
        <PersonalizedHero
          baseline={{ id: heroModule.sys.id, fields: heroModule.fields }}
          experiences={experiences}
          exposures={{}}
        />
      </ModuleErrorBoundary>
    );
  }

  return (
    <ModuleErrorBoundary key={heroModule.sys.id}>
      <HeroClient {...heroModule.fields} />
    </ModuleErrorBoundary>
  );
}

export function renderCardSectionModuleClient(module: PageModule) {
  const cardSectionModule = getEntryOfContentType<TypeCardSection<undefined, string>>(module, "cardSection");
  if (!cardSectionModule) return null;

  const experiences = mapCardSectionExperiences(cardSectionModule.fields.nt_experiences);
  if (experiences.length > 0) {
    return (
      <ModuleErrorBoundary key={cardSectionModule.sys.id}>
        <PersonalizedCardRow
          baseline={{ id: cardSectionModule.sys.id, fields: cardSectionModule.fields }}
          experiences={experiences}
          exposures={{}}
        />
      </ModuleErrorBoundary>
    );
  }

  return (
    <ModuleErrorBoundary key={cardSectionModule.sys.id}>
      <CardRow {...cardSectionModule.fields} />
    </ModuleErrorBoundary>
  );
}
